import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled from 'styled-components';
import { useTaktId, createStormTaktId, Button, Icon } from '@amzn/storm-ui';
import { u as useIntl } from '../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-voJ4yxcS-DU7lWLPF.js';
import { a as angleDown } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-D_8tzsxC.js';

const MAX_BUTTON_LABEL_LENGTH = 67;
const TriggerIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40027066__sc-1e58mq7-0"
})(["margin-inline-start:", ";"], ({
  theme
}) => theme.spacing.xxsmall.default);
const CountrySelectorTrigger = /*#__PURE__*/React__default.forwardRef(({
  selected,
  onClick,
  taktId,
  taktValue,
  ...rest
}, ref) => {
  const {
    formatMessage
  } = useIntl();
  const {
    getDataTaktAttributes
  } = useTaktId({
    taktId,
    fallbackId: createStormTaktId('country-selector-trigger-button')
  });
  let label;
  if (!selected || selected.length === 0) {
    // Render "Choose a country" for an adjustable country selector when no countries are currently selected
    label = formatMessage({
      id: 'trigger-button-choose-country-label'
    });
  } else if (selected.length === 1) {
    // Render the country name when only one country is selected
    label = formatMessage({
      id: `option-label-${selected[0]}`
    });
  } else if (selected.length > 1) {
    /**
     * Render the amount of selected countries and the comma separated list
     * of country names, when two or more countries are currently selected
     */
    const countryNames = selected.map(id => formatMessage({
      id: `option-label-${id}`
    }));
    const translatedLabel = formatMessage({
      id: 'trigger-button-number-selected-label'
    }, {
      // eslint-disable-next-line id-length
      n: selected.length,
      commaSeparatedCountriesList: countryNames.join(', ')
    });
    label = translatedLabel.length > MAX_BUTTON_LABEL_LENGTH ? `${translatedLabel.substring(0, MAX_BUTTON_LABEL_LENGTH - 3)}...` : translatedLabel;
  }
  return /*#__PURE__*/React__default.createElement(Button, _extends({}, getDataTaktAttributes({
    taktValue
  }), rest, {
    onClick: label === '' ? undefined : onClick,
    loading: !label,
    buttonRef: ref
  }), label, /*#__PURE__*/React__default.createElement(TriggerIcon, {
    type: angleDown
  }));
});

export { CountrySelectorTrigger as C };
//# sourceMappingURL=CountrySelectorTrigger-BEb2y1K0.js.map
